import styled from 'styled-components'
import { anatomyCompact } from '~/pages/anatomy/libs/responsive'
import { anatomyH1Css, anatomyRootCss } from '~/pages/anatomy/libs/styles'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  Root: styled.div`
    ${anatomyRootCss}
  `,

  StyledContainer: styled(Container)`
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 24px 16px;

    ${anatomyCompact} {
      overflow-y: auto;
    }
  `,

  Question: styled.h1`
    ${anatomyH1Css}
    margin-bottom: 24px;
  `,

  ImageWrapper: styled.div`
    max-width: 260px;
    width: 100%;
    margin: 0 auto 32px;
    border-radius: 16px;
    overflow: hidden;

    picture {
      display: block;
    }

    img {
      width: 100%;
      display: block;
    }
  `,

  OptionsGrid: styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: 1fr;
    gap: 12px;
    margin-top: auto;
  `,

  OptionButton: styled.button<{ $isSelected?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    background: ${({ $isSelected }) =>
      $isSelected ? COLORS.PURPLE_100 : COLORS.WHITE};
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    touch-action: manipulation;
    border: 1px solid
      ${({ $isSelected }) =>
        $isSelected ? COLORS.PURPLE_500 : COLORS.GRAY_400};
    border-radius: 12px;
    padding: 16px 12px;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    color: ${COLORS.BLACK};

    &:active {
      background: ${({ $isSelected }) =>
        $isSelected ? COLORS.PURPLE_100 : COLORS.WHITE};
    }

    &:disabled {
      opacity: 0.7;
    }
  `,

  EmojiSpan: styled.span`
    font-size: 22px;
  `,
} as const
